import {Injectable} from '@angular/core';
import {ApiService} from 'amc-common-components';
import {Observable} from 'rxjs';
import {
	CtsEditModalParams,
	CtsEditPeriodData,
	CtsTableDataWithPagination,
} from '@entities/cts-distribution/cts-distribution.interfaces';
import {
	CtsDistributionTableParams,
	CtsSavedRowResponse,
} from '@entities/cts-distribution/cts-distribution-api-interfaces';
import {ItemCommon} from '@entities/common/common.interface';
import {CtsDistributionApiMapper} from './cts-distribution.api.mapper';

/**
 * This class is an injectable Angular service that provides a way to fetch data..
 */
@Injectable()
export class CtsDistributionApiService {
	/**
	 * Constructor for CtsDistributionApiService.
	 */
	constructor(private readonly api: ApiService) {}

	/**
	 * API method Get Table Data for 'distribution_mapping/get_distribution_mapping' response.
	 * @param {CtsDistributionTableParams} params
	 * @returns {Observable<CtsTableDataWithPagination>}
	 */
	getTableData(params: CtsDistributionTableParams): Observable<CtsTableDataWithPagination> {
		return this.api.post(
			'distribution_mapping/get_distribution_mapping',
			params,
			CtsDistributionApiMapper.mapTableData
		);
	}

	/**
	 * API method Get Platform Filter for 'distribution_mapping/get_distribution_mapping_platform_filter' response.
	 * @returns {Observable<ItemCommon[]>}
	 */
	getPlatformFilter(): Observable<ItemCommon[]> {
		return this.api.get(
			'distribution_mapping/get_distribution_mapping_platform_filter',
			CtsDistributionApiMapper.mapPlatformFilter
		);
	}

	/**
	 * API method Get Period Filter for 'distribution_mapping/get_distribution_mapping_date_filter' response.
	 * @returns {Observable<CtsEditPeriodData>}
	 */
	getPeriodFilter(): Observable<CtsEditPeriodData> {
		return this.api.get(
			'distribution_mapping/get_distribution_mapping_date_filter',
			CtsDistributionApiMapper.mapPeriodFilter
		);
	}

	/**
	 * API method Get Period Filter for 'distribution_mapping/get_distribution_mapping_product_type_filter' response.
	 * @returns {Observable<ItemCommon[]>}
	 */
	getProgramTypeFilter(): Observable<ItemCommon[]> {
		return this.api.get(
			'distribution_mapping/get_distribution_mapping_product_type_filter',
			CtsDistributionApiMapper.mapProgramTypeFilter
		);
	}

	/**
	 * API method Save Rows for 'distribution_mapping/put_distribution_mapping' response.
	 * @param {CtsEditModalParams} payload
	 * @returns {Observable<CtsSavedRowResponse>}
	 */
	saveRows(payload: CtsEditModalParams): Observable<CtsSavedRowResponse> {
		return this.api.post('distribution_mapping/put_distribution_mapping', payload);
	}
}
